import React, { useState, useEffect } from 'react';
import { saveServiceTargets, getServiceTargets } from '../../services/target.service';
import '../../styles/admin-dashboard.css';

const TargetAchievement = () => {
    const [targets, setTargets] = useState({
        'Financial Diagnosis': 0,
        'Roadmap': 0,
        'Hands-on': 0,
        'Coaching Training': 0
    });
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        fetchTargets();
    }, []);

    const fetchTargets = async () => {
        try {
            setLoading(true);
            const data = await getServiceTargets();
            setTargets(data);
        } catch (error) {
            console.error('Error fetching targets:', error);
            setMessage({ type: 'error', text: 'Failed to load existing targets' });
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (category, value) => {
        setTargets(prev => ({
            ...prev,
            [category]: parseInt(value) || 0
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setSaving(true);
            setMessage({ type: '', text: '' });
            await saveServiceTargets(targets);
            setMessage({ type: 'success', text: 'Targets updated successfully!' });

            // Clear message after 3 seconds
            setTimeout(() => setMessage({ type: '', text: '' }), 3000);
        } catch (error) {
            console.error('Error saving targets:', error);
            setMessage({ type: 'error', text: 'Failed to save targets' });
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return (
            <div className="admin-content-v2">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', width: '100%' }}>
                    <div className="custom-loader" style={{ width: '55px', height: '80px' }}>
                        <svg viewBox="0 0 55 80" xmlns="http://www.w3.org/2000/svg" fill="#0EAB5EFF">
                            <g transform="matrix(1 0 0 -1 0 80)">
                                <rect width="10" height="20" rx="3">
                                    <animate attributeName="height" begin="0s" dur="4.3s" values="20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20" calcMode="linear" repeatCount="indefinite" />
                                </rect>
                                <rect x="15" width="10" height="80" rx="3">
                                    <animate attributeName="height" begin="0s" dur="2s" values="80;55;33;5;75;23;73;33;12;14;60;80" calcMode="linear" repeatCount="indefinite" />
                                </rect>
                                <rect x="30" width="10" height="50" rx="3">
                                    <animate attributeName="height" begin="0s" dur="1.4s" values="50;34;78;23;56;23;34;76;80;54;21;50" calcMode="linear" repeatCount="indefinite" />
                                </rect>
                                <rect x="45" width="10" height="30" rx="3">
                                    <animate attributeName="height" begin="0s" dur="2s" values="30;45;13;80;56;72;45;76;34;23;67;30" calcMode="linear" repeatCount="indefinite" />
                                </rect>
                            </g>
                        </svg>
                    </div>
                    <p style={{ marginTop: '20px', color: '#64748B', fontWeight: 500 }}>Loading target settings...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="admin-content-v2">
            <div className="dashboard-top-nav-v2">
                <div className="top-nav-left-v2">
                    <h1 className="nav-title-v2">Service Target Management</h1>
                    <p className="nav-subtitle-v2">Set monthly goals for each vertical</p>
                </div>
            </div>

            <div className="target-form-container" style={{ maxWidth: '600px', margin: '40px 0', background: 'white', padding: '32px', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}>
                <form onSubmit={handleSubmit}>
                    <div className="form-grid" style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                        {Object.keys(targets).map((category) => (
                            <div key={category} className="form-group" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                <label style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b', marginBottom: '4px' }}>
                                    {category} Target (Monthly)
                                </label>
                                <input
                                    type="number"
                                    min="0"
                                    value={targets[category]}
                                    onChange={(e) => handleInputChange(category, e.target.value)}
                                    placeholder="Enter monthly target"
                                    style={{
                                        padding: '14px 16px',
                                        borderRadius: '8px',
                                        border: '1px solid #e2e8f0',
                                        fontSize: '15px',
                                        outline: 'none',
                                        transition: 'border-color 0.2s',
                                        width: '100%',
                                        backgroundColor: '#f8fafc'
                                    }}
                                    onFocus={(e) => e.target.style.borderColor = '#1e293b'}
                                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                                />
                            </div>
                        ))}
                    </div>

                    {message.text && (
                        <div className={`message-alert ${message.type}`} style={{ marginTop: '20px', padding: '12px', borderRadius: '6px', fontSize: '14px', textAlign: 'center', backgroundColor: message.type === 'success' ? '#dcfce7' : '#fee2e2', color: message.type === 'success' ? '#166534' : '#991b1b' }}>
                            {message.text}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={saving}
                        className="btn-v2"
                        style={{
                            marginTop: '40px',
                            width: '100%',
                            justifyContent: 'center',
                            background: '#1e293b',
                            color: 'white',
                            height: '52px',
                            borderRadius: '8px',
                            fontSize: '16px',
                            fontWeight: '600',
                            border: 'none',
                            cursor: 'pointer',
                            opacity: saving ? 0.7 : 1,
                            transition: 'all 0.2s'
                        }}
                    >
                        {saving ? (
                            <>
                                <div className="spinner-micro" style={{ marginRight: '8px' }}></div>
                                Saving...
                            </>
                        ) : 'Update Monthly Targets'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default TargetAchievement;
